module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Leanne Banks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Leanne Banks")]), _vm._v(" is a popular bestselling romance star who has written over 20 books for Silhouette and HQN. She is known for her very humorous contemporary romance novels that have a strong undercurrent of emotion as well as her savvy self-promotion.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/olzYHB/tc-custom/9780446548359.jpg?1737194764000",
      "alt": "This image is the cover for the book Some Girls Do, Sisters Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Some Girls Do, Sisters Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Every girl from eighteen to eighty will love” this story of a plain Jane matchmaker who lands a sexy security agent. “The best feel-good book you’ll read this year” (Janet Evanovich, #1 "), _c('i', [_vm._v("New York Times–")]), _vm._v("bestselling author of the Stephanie Plum series).")]), _c('br'), _c('br'), _vm._v("Katie Collins, a tycoon's personal assistant, is assigned to find a suitable husband for his too-shy daughter. But in an unexpected turn of events, Wilhemina takes off for Texas, determined to find herself a cowboy instead! Now Katie is on the trail of the rebellious heiress, along with her boss’s bodyguard, sexy Michael Wingate. And soon enough, the sparks are flying between Katie and Michael, making their road trip a whole lot hotter. . . . "), _c('br'), _c('br'), _vm._v(" “Banks's prose sparkles with energy and heart.” —"), _c('i', [_vm._v("Publishers Weekly ")]), _c('br'), _c('br'), _vm._v("“A witty feel-good read with charming characters and a page-turning plot.” —"), _c('i', [_vm._v("Booklist")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Warner Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0